import { render, staticRenderFns } from "./InterParcel.vue?vue&type=template&id=15368320"
import script from "./InterParcel.vue?vue&type=script&lang=js"
export * from "./InterParcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports